import React, { useEffect, useMemo, useState } from "react";
import { IPopover } from "./popover.d.ts";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Popover } from "react-bootstrap";

import { ContainerButton } from "./styles";
import Button from "../Button";

/**
 * Componente de botão
 * @param {IPopover} props - Props do componente
 * @returns {JSX.Element} Componente do botão
 **/

const TmPopover = ({ iconButton, labelButton, children, forceClose, onChange, placement = "top" }) => {
	const [isOpened, setIsOpened] = useState(false);

	useEffect(() => {
		onChange(isOpened);
	}, [isOpened]);

	useEffect(() => {
		if (forceClose === undefined) return;
		setIsOpened(!forceClose);
	}, [forceClose]);

	const popover = useMemo(() => <Popover id="popover-basic">{children}</Popover>, [children]);

	return (
		<ContainerButton>
			<OverlayTrigger
				show={isOpened}
				trigger="click"
				placement={placement}
				overlay={popover}
				onToggle={() => {
					setIsOpened(!isOpened);
				}}
			>
				<Button title={labelButton} icons={iconButton} />
			</OverlayTrigger>
		</ContainerButton>
	);
};

export default TmPopover;
